package com.kinoshazam.uiKit.components.selectableText

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldMedium
import com.kinoshazam.uiKit.theme.Medium
import com.kinoshazam.uiKit.theme.UiKitTheme

@Composable
fun SelectableTextView(
    state: SelectableTextState,
    modifier: Modifier = Modifier,
    onAction: () -> Unit = {}
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()
    val shape = RoundedCornerShape(36.dp)
    // Hover fill only for non-selected items; selected keeps the outline style.
    val showHoverFill = isHovered && !state.isSelected

    Box(
        modifier = modifier
            .clip(shape)
            .then(
                if (showHoverFill) {
                    Modifier.background(UiKitTheme.colors.color_1, shape)
                } else {
                    Modifier
                }
            )
            .then(
                if (state.isSelected) {
                    Modifier.border(
                        BorderStroke(2.dp, UiKitTheme.colors.color_1),
                        shape,
                    )
                } else {
                    Modifier
                }
            )
            .clickable(
                interactionSource = interactionSource,
                indication = null,
                onClick = onAction,
            ),
        contentAlignment = Alignment.Center,
    ) {
        val labelPadding = Modifier.padding(horizontal = 20.dp, vertical = 10.dp)
        // Invisible bold text reserves width so hover bold doesn't shift neighbors.
        TextLabel(
            state = TextLabelState(
                text = state.title,
                color = UiKitTheme.colors.color_2,
                textStyle = BoldMedium,
            ),
            modifier = labelPadding.alpha(0f),
        )
        TextLabel(
            state = TextLabelState(
                text = state.title,
                color = UiKitTheme.colors.color_2,
                textStyle = if (isHovered) BoldMedium else Medium,
            ),
            modifier = labelPadding,
        )
    }
}
